module.exports = __webpack_public_path__ + "img/بدون-متن.8c4983a8.jpg";